import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import PageLayout from '../components/common/PageLayout';
import { useAuth } from '../contexts/AuthContext';

const AREAS = [
  { id: 'orders', label: 'Orders', path: '/orders', perms: ['orders:view', 'orders:edit', 'orders:create', 'orders:delete'] },
  { id: 'devotees', label: 'Devotees', path: '/devotees', perms: ['devotees:view', 'devotees:edit', 'devotees:create', 'devotees:delete'] },
  { id: 'pledges', label: 'Pledges', path: '/pledges', perms: ['pledges:view', 'pledges:edit', 'pledges:create', 'pledges:delete'] },
  { id: 'reports', label: 'Reports', path: '/reports', perms: ['event_reports:access', 'sponsors_reports:access', 'reports:view'] },
  { id: 'campaigns', label: 'Campaigns', path: '/temple/campaigns', perms: ['communications:access', 'temple:access', 'admin:full'] },
  { id: 'manage', label: 'Manage', path: '/manage', perms: ['reports:view', 'users:manage'] },
  { id: 'settings', label: 'Settings', path: '/settings', perms: ['settings:access'] },
  { id: 'users', label: 'User management', path: '/manage/users', perms: ['users:manage'] },
  { id: 'meetings', label: 'Meetings', path: '/meetings', perms: ['meetings:access'] },
  { id: 'analytics', label: 'Analytics', path: '/analytics', perms: ['analytics:view'] },
];

function hasAnyInArea(permissions, areaPerms) {
  if (!Array.isArray(permissions)) return false;
  return areaPerms.some(p => permissions.includes(p));
}

// admin:full (or role admin) => no restriction; show all areas
function canAccessArea(perms, staffRole, areaPerms) {
  if (perms.includes('admin:full')) return true;
  if (String(staffRole || '').toLowerCase() === 'admin') return true;
  return hasAnyInArea(perms, areaPerms);
}

const WelcomePage = () => {
  const { staff } = useAuth();
  const navigate = useNavigate();
  const perms = Array.isArray(staff?.permissions) ? staff.permissions : [];
  const name = staff?.name || staff?.email || 'User';

  const visibleAreas = AREAS.filter(area => canAccessArea(perms, staff?.role, area.perms));

  return (
    <PageLayout contentMaxWidth="md" showHeaderImage={false} showOrgHeader>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Welcome, {name}
      </Typography>
      <Grid container spacing={2}>
        {visibleAreas.map(area => (
          <Grid item xs={12} sm={6} key={area.id}>
            <Card variant="outlined" sx={{ height: '100%' }}>
              <CardActionArea onClick={() => navigate(area.path)} sx={{ height: '100%', display: 'block' }}>
                <CardContent>
                  <Typography variant="h6">{area.label}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      {visibleAreas.length === 0 && (
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">You don’t have access to any areas yet. Contact an administrator.</Typography>
        </Box>
      )}
    </PageLayout>
  );
};

export default WelcomePage;
